export const getExportJobFilename = (exportJob) => {
  return exportJob.exportFilename ? `${exportJob.exportFilename}.csv` : exportJob.name;
};
